import React from "react";
import { useMediaQuery } from "react-responsive";
import { getPageImages } from "@/config/imagePaths";
import { useGlobalStore } from "@/stores";

import "./index.scss";

const Login: React.FC = () => {
  const {
    currentLanguage: lang,
    isLoggedIn,
    handleLogin,
    handleLogout,
  } = useGlobalStore();

  console.log({ isLoggedIn });

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const batchImages = getPageImages(lang);

  // 根据登录状态决定显示类型和点击行为
  const type = isLoggedIn ? "logout" : "login";
  const handleClick = isLoggedIn ? handleLogout : handleLogin;

  return (
    <div
      className={`login-btn ${isMobile ? "mobile" : "pc"}`}
      onClick={handleClick}>
      <img src={batchImages[`pc_p1_${type}_png`]} alt='' />
    </div>
  );
};

export default Login;
